import { render, staticRenderFns } from "./weaStaCard.vue?vue&type=template&id=70870600&scoped=true"
import script from "./weaStaCard.vue?vue&type=script&lang=js"
export * from "./weaStaCard.vue?vue&type=script&lang=js"
import style0 from "./weaStaCard.vue?vue&type=style&index=0&id=70870600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70870600",
  null
  
)

export default component.exports